<template>
  <component :is="linkTag" v-bind="$attrs" v-on="$listeners" :class="fake && 'cursor-pointer'">
    <sg-text
      :tag="tag"
      v-bind="{ ...colorProps, large, regular, small, micro }"
      class="inline-flex items-center underline font-medium hover:text-navy-600"
    >
      <slot />
    </sg-text>
  </component>
</template>

<script>
export default {
  props: {
    anchor: { type: Boolean, default: false },
    fake: { type: Boolean, default: false },
    tag: { type: String, default: 'span' },

    large: Boolean,
    regular: Boolean,
    small: Boolean,
    micro: Boolean,

    light: Boolean,
    dark: Boolean,
  },

  computed: {
    linkTag() {
      if (this.fake) {
        return 'div';
      } else if (this.anchor) {
        return 'a';
      }

      return 'inertia-link';
    },
    colorProps() {
      if (this.light) return { gray: true };
      if (this.dark) return { white: true };
    },
  },
};
</script>
